import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Wordmark } from "@/components/Logo";
import { Button } from "@/components/UI";

export default function Login() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user && user.role === "admin") nav("/admin"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-ccpm-charcoal flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-10"><Wordmark light /></div>
        <div className="bg-ccpm-ivory p-10 border border-ccpm-border">
          <p className="overline text-ccpm-olive mb-2">Council Administration</p>
          <h1 className="font-serif text-3xl text-ccpm-charcoal mb-8">Sign in</h1>
          <form onSubmit={submit} data-testid="login-form">
            <label className="overline text-ccpm-taupe block mb-2">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
              className="w-full px-3 py-3 bg-white border border-ccpm-border text-sm mb-5 focus:outline-none focus:border-ccpm-olive" />
            <label className="overline text-ccpm-taupe block mb-2">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
              className="w-full px-3 py-3 bg-white border border-ccpm-border text-sm focus:outline-none focus:border-ccpm-olive" />
            {error && <p className="mt-4 text-sm text-red-700" data-testid="login-error">{error}</p>}
            <Button type="submit" disabled={busy} className="mt-8 w-full" data-testid="login-submit">
              {busy ? <><Loader2 size={16} className="animate-spin" /> Signing in…</> : "Sign in"}
            </Button>
          </form>
        </div>
        <button onClick={() => nav("/")} className="mt-6 mx-auto block text-sm text-ccpm-olive-soft hover:text-ccpm-ivory">← Back to website</button>
      </div>
    </div>
  );
}
